import { render, staticRenderFns } from "./PurchaseInvoiceItemReview.vue?vue&type=template&id=693ee1ac&scoped=true&lang=pug&"
import script from "./PurchaseInvoiceItemReview.vue?vue&type=script&setup=true&lang=js&"
export * from "./PurchaseInvoiceItemReview.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./PurchaseInvoiceItemReview.vue?vue&type=style&index=0&id=693ee1ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "693ee1ac",
  null
  
)

export default component.exports